export enum DonationStatus {
    ALL = "all",
    CONFIRMED = "Confirmed",
    CANCELED = "Canceled",
}

export enum DonationType {
    ONE_TIME = "One-time",
    RECURRING = "Recurring",
}

export enum DonationFrequency {
    MONTHLY = "Monthly",
    ANNUALLY = "Annually",
}

export enum DonationCycle {
    MONTH = "Month",
    YEAR = "Year",
}